module.exports = __webpack_public_path__ + "img/20201024_100839.b16eccb3.jpg";